import { render, staticRenderFns } from "./SuggestionItems.vue?vue&type=template&id=626b4171&"
import script from "./SuggestionItems.vue?vue&type=script&lang=js&"
export * from "./SuggestionItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports